import { render, staticRenderFns } from "./_RecordStructureContent.vue?vue&type=template&id=458a4572&scoped=true&"
import script from "./_RecordStructureContent.vue?vue&type=script&lang=js&"
export * from "./_RecordStructureContent.vue?vue&type=script&lang=js&"
import style0 from "./_RecordStructureContent.vue?vue&type=style&index=0&id=458a4572&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458a4572",
  null
  
)

export default component.exports